import { dcpcApi } from './dcpcApi';

const NOTIFICATIONS_HEADERS_TAG = 'NotificationsHeaders';

dcpcApi.enhanceEndpoints({ addTagTypes: [NOTIFICATIONS_HEADERS_TAG] });
const notificationsHeadersApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getNotificationsHeaders: builder.query({
      query: (params) => ({
        url: 'notification-app-logs',
        method: 'GET',
        params,
      }),
      providesTags: [NOTIFICATIONS_HEADERS_TAG],
    }),

    deleteNotificationsHeader: builder.mutation({
      query: (body) => ({
        url: 'notification-app-logs',
        method: 'DELETE',
        body,
      }),
      invalidatesTags: [NOTIFICATIONS_HEADERS_TAG],
    }),
  }),
});

export const {
  useGetNotificationsHeadersQuery,
  useLazyGetNotificationsHeadersQuery,
  useDeleteNotificationsHeaderMutation,
} = notificationsHeadersApi;
// Current Notification
